import React from "react";

import Button from "~/ui/button";

import styles from "../css/DeveloperApi.module.css";

interface EmptyStateProps {
	title: string;
	description: string;
	onNewKey?: () => void;
}

export const EmptyState = (props: EmptyStateProps) => {
	return (
		<div className={styles.developerApiSettingsEmptyState}>
			<div className={styles.developerApiSettingsEmptyStateTitle}>{props.title}</div>
			<div className={styles.developerApiSettingsEmptyStateDescription}>{props.description}</div>
			{props.onNewKey && <Button onClick={props.onNewKey}>Create new API key</Button>}
		</div>
	);
};
